var mobile_breakpoint = 992;
$(function () {
    // PRODUCT CTA BAR
    $(document).ready(function() { 
        update_product_cta_bar();
        $(window).on('resize', function() {
            if ( $(window).width() < mobile_breakpoint && $(window).scrollTop() > $('.add-to-cart').offset().top-60 ) {
                if ( Math.trunc($('.add-to-cart-bar-btn').outerWidth()) !== Math.trunc($('.add-to-cart').outerWidth()) ) {
                    $('.add-to-cart-bar-btn').css('width', $('.add-to-cart').outerWidth() );
                }
            } else if ( $(window).width() >= mobile_breakpoint && $(window).scrollTop() > $('.add-to-cart').offset().top ) {
                if ( Math.trunc($('.add-to-cart-bar-btn').outerWidth()) !== '345' ) {
                    $('.add-to-cart-bar-btn').css('width', '345px');
                }
            }
        });
    });
    $(window).scroll( function() { update_product_cta_bar() } );
    function update_product_cta_bar () {
        if ($(window).width() < mobile_breakpoint && $(window).scrollTop() > $('.add-to-cart').offset().top-60 || 
            $(window).width() >= mobile_breakpoint && $(window).scrollTop() > $('.add-to-cart').offset().top) {
                $('#product_cta_bar').removeClass('d-none');
                if ( Math.trunc($('.add-to-cart-bar-btn').outerWidth()) === Math.trunc($('.add-to-cart').outerWidth()) || $('.add-to-cart-bar-btn').width() <= 0 ) {
                    if ( $(window).width() >= mobile_breakpoint ) {
                        if ( $('.add-to-cart-bar-btn').width() <= 0 ) {
                            $('.add-to-cart-bar-btn').css('width', '345px');
                        } else {
                            $('.add-to-cart-bar-btn').stop().animate({'width':'345px'}, 250);
                        }
                    } else { 
                        $('.add-to-cart-bar-btn').css('width', $('.add-to-cart').outerWidth() );
                    }
                } 
        } else {
            $('#product_cta_bar').addClass('d-none');
            $('.add-to-cart-bar-btn').css('width', $('.add-to-cart').outerWidth() );
        }
    
        if ( $(window).scrollTop() > $('#product_features_ghost').offset().top-$('#product_cta_bar').outerHeight() ) {
            $('#product_features_ghost').height($('#product_features_menu_content').outerHeight()+30);
            $('#product_features_menu').css('margin-top', $('#product_cta_bar').outerHeight());
            $('#product_features_menu').addClass('fixed-top');
        } else {
            $('#product_features_ghost').css('height', 0);
            $('#product_features_menu').css('margin-top', 0);
            $('#product_features_menu').removeClass('fixed-top');
        }
    }
    
    $('#product_features_current').click(function() {
        $('#product_features_options').slideToggle();
        $('#product_features_current .fa-angle-down').toggleClass('rotate180');
    });
    
    $('.product-features-option').click(function() {
        if ( !$(this).hasClass('active') ) {
            $('.product-features-option').removeClass('active');
            $(this).addClass('active');
            
            $('.product-section-content').slideUp();
            $('#'+$(this).attr('data-target')).slideDown();
            $('html, body').animate({scrollTop: $('#product_features_ghost').offset().top-$('#product_cta_bar').height()+35}, 500);
            
            if ( $(window).width() < mobile_breakpoint ) {
                $('#product_features_options').slideUp();
                $('#product_features_current .active').text( $(this).text() );
                $('#product_features_current .fa-angle-down').removeClass('rotate180');
            }
        } else {
            $('html, body').animate({scrollTop: $('#product_features_ghost').offset().top-$('#product_cta_bar').height()+35}, 500);
            
            if ( $(window).width() < mobile_breakpoint ) {
                $('#product_features_options').slideUp();
                $('#product_features_current .active').text( $(this).text() );
                $('#product_features_current .fa-angle-down').removeClass('rotate180');
            }
        }
    });
    
  	// SCROLL WITH SCREEN
    if ( $(document).width() >= mobile_breakpoint) {
        $(document).scroll(function() {
          	var offsetTurntable = 30;
          	var paddingTurntable = ( $(window).height() - $('#product_turntable_wrapper').height() - $('#product_turntable_swipe').height() - $('#product_carousel_wrapper').outerHeight(true) ) / 2;
          	var paddingLimit = $('.product-sidebar').outerHeight(true) - $('#product_turntable_wrapper').height() - $('#product_turntable_swipe').height() - $('#product_carousel_wrapper').outerHeight(true) - $('.nav-container').height() - 50;
          	if ( $(document).scrollTop() >= 30 ) {
          	    if ( paddingLimit > paddingTurntable - 20 - $('.nav-container').height() + $(document).scrollTop() ) {
          	        offsetTurntable = paddingTurntable - 20 - $('.nav-container').height() + $(document).scrollTop();
          	    } else {
          	        offsetTurntable = paddingLimit;
          	    }
          	}
        	$('#product_turntable_div').css('margin-top', offsetTurntable);
        });
    }
    
    // CAROUSEL IMAGES
    $('#product_carousel_images').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2000,
        centerMode: false,
        centerPadding: '30px',
        dots: false,
        draggable: false,
        initialSlide: 1,
        infinite: true,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        respondTo: 'min',
        slidesToShow: 1,
        slidesToScroll: 1,
        touchMove: true,
        variableWidth: true
    });
    // POPUP IMAGES
    $('.single-popup').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        image: {
            verticalFit: true
        }
    });
    // TURNTABLE
    function turntable_control() {
        var tab_breakpoint = mobile_breakpoint,
            document_width = $(document).width();
        if (tab_breakpoint < document_width) {
            // desktop
            $('#product_still_image, #product_turntable_close_btn, #product_turntable_open_btn').hide();
            $('#product_turntable_div').show();
            $('#product_turntable_wrapper').turntable();
        } else {
            // mobile
            $('#product_still_image, #product_turntable_close_btn, #product_turntable_open_btn').show();
            $('#product_turntable_div').hide();
        }
    }
    turntable_control();
    $('#product_turntable_open_btn').click(function (e) {
        e.preventDefault();
        $('#product_turntable_div, #product_turntable_close_btn').show();
        $('#product_still_image').hide();
        $('#product_turntable_wrapper').turntable();
        $('body').addClass('overflow-hidden');
    });
    $('#product_turntable_close_btn').click(function (e) {
        e.preventDefault();
        $('#product_turntable_div').hide();
        $('#product_still_image').show();
        $('body').removeClass('overflow-hidden');
    });
    $(window).resize(function() {
        //collection_adjust_tab();
        turntable_control();
        $('body').removeClass('overflow-hidden');
        $('.footer-collection-margin').css('height', $('#footer_cart').outerHeight());
        $('.zopim, #proonto-widget').css('transform', 'translateY(-'+$('#footer_cart').outerHeight()+'px)');
    });
    // STAMPED.IO
    var checkExist = setInterval(function() {
        if ($('.stamped-badge-caption').length) {
            clearInterval(checkExist);
            var reviews = parseInt($('.stamped-badge-caption').data('reviews'));
            var ratings = parseFloat($('.stamped-badge-caption').data('rating'));
            // reviews count on the tab
            $('.added-stamped-reviews-count-balloon').html('('+reviews+')');
            // the new stars
            var full_star = '<svg class="fa-c-star" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"><polygon style="fill:#FFC107" points="25,1.33 32.69,17.91 49.88,18.41 37.44,31.54 40.38,48.67 25,40.58 9.62,48.67 12.56,31.54 0.12,18.41 17.31,17.91 "/></svg>';
            var half_star = '<svg class="fa-c-star-half" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"><polygon style="fill:#FFC107" points="25,1.33 17.31,17.91 0.12,18.41 12.56,31.54 9.62,48.67 25,40.58 "/><g><path style="fill:#FFC107" d="M25,7.28l5.42,11.69l0.65,1.4l1.55,0.04l11.61,0.34l-8.6,9.07l-0.86,0.91l0.21,1.23l2.08,12.13l-10.89-5.73L25,37.76l-1.16,0.61L12.94,44.1l2.08-12.13l0.21-1.23l-0.86-0.91l-8.6-9.07l11.61-0.34l1.55-0.04l0.65-1.4L25,7.28 M25,1.33l-7.69,16.58l-17.19,0.5l12.44,13.13L9.62,48.67L25,40.58l15.38,8.09l-2.94-17.12l12.44-13.13l-17.19-0.5L25,1.33L25,1.33z"/></g></svg>';
            $('#stamped_reviews_count').html(reviews);
            $('#stamped_reviews_rating').html(ratings);
            $('#the_four_stars').html(full_star+full_star+full_star+full_star);
            if (5.0 == ratings) {
                $('#the_last_star').html(full_star);
            } else {
                $('#the_last_star').html(half_star);
            }
        }
    }, 100);
    $('.new-stars').click(function () {
        $('#product_features_reviews').click();
    });
  $('#product_add_on_lightbox_yes').click(function() {
   	$('#product_add_on_yes').click();
    $('#lightbox_addon').hide();
  });
  $('#product_add_on_lightbox_no').click(function() {
   	$('#product_add_on_no').click();
    $('#lightbox_addon').hide();
  });
  $('.lightbox-container').click(function(e) {
    if ($(e.target).hasClass('lightbox-container')) {
      $('#lightbox_addon').hide();
    }
  });
  $('.lightbox-close').click(function() {
    $('#lightbox_addon').hide();
  });
  
  $(document).ready(function() {
    $('.product-add-on-slider-feature').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      arrows: false,
      fade: true,
      asNavFor: '.product-add-on-slider-nav'
    });
    $('.product-add-on-slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product-add-on-slider-feature',
      arrows: false,
      focusOnSelect: true
    });
  });
});